// extracted by mini-css-extract-plugin
export default {"sortButton":"sortbuttonsingle_sortButton__MJdS5"};